import React from 'react'
import Routing from './Routing'
import { BrowserRouter } from "react-router-dom";

export default () => (
    <BrowserRouter>
        <Routing />
    </BrowserRouter>
)